const { TARGET_ENV = 'production' } = process.env;
const transactionId = require('uuid/v4')();

const environment = {
  development: {
    firebaseConfig: {
      apiKey: 'AIzaSyD6bTMsNjHHxlRikFYdKhiL3t1eFMzy9X0',
      authDomain: 'cryptoket-dev.firebaseapp.com',
      databaseURL: 'https://cryptoket-dev.firebaseio.com',
      projectId: 'cryptoket-dev',
      storageBucket: 'cryptoket-dev.appspot.com',
      messagingSenderId: '880931338696',
    },
    apiUrl: 'https://wallet-dev.cryptoket.io/v1',
    apiUrl2: 'https://wallet-dev.cryptoket.io',
    fileUploadUrl: 'http://listener.cryptoket.io:5100',
    SENTRY_ENVIRONMENT: 'development',
    TRANSACTION_ID: transactionId,
  },
  staging: {
    firebaseConfig: {
      apiKey: 'AIzaSyDzyE4j_d9hMfEgCnA3Bzs1BOmpRdWo1WM',
      authDomain: 'cryptoket.firebaseapp.com',
      databaseURL: 'https://cryptoket.firebaseio.com',
      projectId: 'cryptoket',
      storageBucket: 'cryptoket.appspot.com',
      messagingSenderId: '914677057615',
    },
    apiUrl: 'https://wallet.cryptoket.io/v1',
    apiUrl2: 'https://wallet.cryptoket.io',
    fileUploadUrl: 'https://api.cryptoket.io',
    SENTRY_ENVIRONMENT: 'staging',
    TRANSACTION_ID: transactionId,
  },
  production: {
    firebaseConfig: {
      apiKey: 'AIzaSyDzyE4j_d9hMfEgCnA3Bzs1BOmpRdWo1WM',
      authDomain: 'cryptoket.firebaseapp.com',
      databaseURL: 'https://cryptoket.firebaseio.com',
      projectId: 'cryptoket',
      storageBucket: 'cryptoket.appspot.com',
      messagingSenderId: '914677057615',
    },
    apiUrl: 'https://api.belibit.co.in/v1',
    apiUrl2: 'https://api.belibit.co.in',
    fileUploadUrl: 'https://api.cryptoket.io',
    SENTRY_ENVIRONMENT: 'production',
    TRANSACTION_ID: transactionId,
  },
};

module.exports = environment[TARGET_ENV];
